// ═══════════════════════════════════════════════════════════════
// PACE — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconAntenna, IconPhone, IconFileText,
  IconChartBar, IconUsers,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import ModuleNav from '../../components/layout/ModuleNav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/pace', icon: IconLayoutDashboard, exact: true },
  { label: 'My PACE', path: '/pace/my-pace', icon: IconAntenna },
  { label: 'Directory', path: '/pace/directory', icon: IconUsers },
  { label: 'Call-Downs', path: '/pace/calldowns', icon: IconPhone },
  { label: 'Plans', path: '/pace/plans', icon: IconFileText },
  { label: 'Reports', path: '/pace/reports', icon: IconChartBar, minLevel: 'editor' },
];

export default function PaceLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('pace', NAV_ITEMS);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      <Breadcrumbs
        items={[
          { label: 'Hub', to: '/' },
          { label: 'PACE', to: '/pace' },
          ...(currentPage && currentPage.path !== '/pace' ? [{ label: currentPage.label }] : []),
        ]}
      />
      <ModuleNav items={visibleItems} accentColor={brand.blurple} />
      <Outlet />
    </div>
  );
}
